var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.3 19.114-7.975 8.383a.778.778 0 0 1-1.151 0l-.481-.513a.91.91 0 0 1 0-1.229L8.619 18.5 1.7 11.245a.91.91 0 0 1 0-1.229l.481-.513a.778.778 0 0 1 1.151 0l7.976 8.383a.917.917 0 0 1-.006 1.228Z",
    fill: "#080808"
  })));
};

export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAxMyAzNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjMwMDYgMTkuMTE0M0wzLjMyNDU0IDI3LjQ5NzFDMy4wMDYzMSAyNy44MzY3IDIuNDkxNzMgMjcuODM2NyAyLjE3MzUgMjcuNDk3MUwxLjY5Mjc3IDI2Ljk4NEMxLjM3NDU0IDI2LjY0NDQgMS4zNzQ1NCAyNi4wOTUxIDEuNjkyNzcgMjUuNzU1NUw4LjYxOTM0IDE4LjVMMS42OTk1NCAxMS4yNDQ2QzEuMzgxMzIgMTAuOTA0OSAxLjM4MTMyIDEwLjM1NTcgMS42OTk1NCAxMC4wMTZMMi4xODAyNyA5LjUwMjk1QzIuNDk4NSA5LjE2MzMgMy4wMTMwOSA5LjE2MzMgMy4zMzEzMiA5LjUwMjk1TDExLjMwNzQgMTcuODg1OEMxMS42MTg4IDE4LjIyNTQgMTEuNjE4OCAxOC43NzQ2IDExLjMwMDYgMTkuMTE0M1oiIGZpbGw9IiMwODA4MDgiLz4KPC9zdmc+Cg==";